import { JsonObject } from '../../helpers';
import { ConnectorApiKeyConfig, ConnectorFeatureSet } from './';
import GeminiIcon from '@/assets/connector-icons/google-gemini.png';
import { ConnectorModel } from './connector.model';

export class GeminiConnectorModel extends ConnectorModel {
  config: ConnectorApiKeyConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'gemini';
    this.typeLabel = 'Google Gemini';
    this.iconSVG = GeminiIcon;

    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: true,
      contextData: false,
      ingress: false,
    };

    this.config = (data.config as ConnectorApiKeyConfig) || {
      apiKey: '',
    };

    this.configSecrets = ['apiKey'];
    this.canListProviderModels = true;
  }
}
